/***************************************************************************
 * ========================================================================
 * Copyright 2024 VMware, Inc. All rights reserved. VMware Confidential
 * ========================================================================
 */

import {
  Component,
  ComponentRef,
  EventEmitter,
} from '@angular/core';
import { each } from 'underscore';

/**
* Attach bindings to a componentRef instance. Used for rendering dynamic components.
*/
export function attachComponentBindings(
  componentRef: ComponentRef<Component>,
  componentBindings: {} = {},
): void {
  each(componentBindings, (prop, key): void => {
    if ((componentRef.instance as Record<string, unknown>)[key] instanceof EventEmitter) {
      (componentRef.instance as Record<string, EventEmitter<unknown>>)[key].subscribe(($event: any) => {
        if (typeof prop === 'function') {
          prop($event);
        }
      });
    } else {
      (componentRef.instance as Record<string, unknown>)[key] = prop;
    }
  });
}
